import { Component, EventEmitter, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

import { ApiService } from 'src/app/config/api.service';
import { CommonService } from '../../services/common/common.service';


@Component({
  selector: 'app-coupon-modal',
  templateUrl: './coupon-modal.component.html',
  styleUrls: ['./coupon-modal.component.scss']
})
export class CouponModalComponent implements OnInit {

  selectedOffer: any;
  category: any;
  clickPosition:any;
  isDetailPage: boolean;
  copiedCode: boolean = false;
  couponLoading: boolean = true;

  redeemActive: boolean = false;
  redeeming = false;
  voucherData:any = {};

  emitRedeem = new EventEmitter<boolean>();


  hideEvent: EventEmitter<boolean> = new EventEmitter();
  redeemStatus: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private _apiService: ApiService,
    private toastr: ToastrService,
    public _bsModalRef: BsModalRef,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.proceedToRedeem();
  }

  failedToRedeem() {
    // this._bsModalRef.hide();
    this.voucherData.success = false;
    this.toastr.error('Something went wrong. Please try again later.','', {
      timeOut: 4000,
    });
    this.couponLoading = false;
  }

  proceedToRedeem() {
    let params = {}
    if (localStorage.getItem('userCard')) {
      params = JSON.parse(localStorage.getItem('userCard'));
    }
    // this.couponLoading = false;
    // this.voucherData = {"success":true,"voucher_code":null};
    this._apiService.redeem({ id: this.selectedOffer.id }, params).subscribe(
      (res: any) => {
        if(res.success == false) {
          this.failedToRedeem();
        } else {
          this.couponLoading = false;
          this.voucherData = res;
          this.redeemStatus.emit(true);
        }
      },
      (err) => {
        if(err.status && err.status === 401){
          this._bsModalRef.hide();
        }
        else{
          this.failedToRedeem();
        }
      }
    );

  }
  hideModal() {
    this.hideEvent.emit(true);
  }
  goTo() {
      this.sendOfferAnalyticsData('redeem');
      this.redeeming = true;
      if(this.selectedOffer.redemption_url){
        setTimeout(() => {
          window.open(this.selectedOffer.redemption_url, '_blank');
          this.redeeming = false;
          this.redeemActive = false;
        }, 0);
      }
  }

  showCopied(code) {
    this.sendOfferAnalyticsData('code_copy');
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success($localize`Copied`,'', {
      timeOut: 4000,
    });

  }

  public sendOfferAnalyticsData(buttonName: string) {        
    const payload =  {
     category: this.category,
     clickPosition:this.clickPosition,
      merchantName: this.selectedOffer.merchant_name,
      merchantID: this.selectedOffer.merchantId,
      offerID : this.selectedOffer.id,
      offerName : this.selectedOffer.offer_title,
      pageURL: this.selectedOffer.redemption_url,
      button_name: buttonName
    }
    this.commonService.sendAnalyticsData('offer_redeem', 'redeemInfo' , payload)
  }

}
